// Footer.jsx
import React from 'react';
// import scfLogo from '../images/soodLogoFooter.png';
import youtube from '../images/youtube.png';
import fb from '../images/Fb.png';
import instagram from '../images/Instagram.png';
import linkedIn from '../images/linkedin.png';
import x from '../images/x.png';
import './Footer.css';

const Footer = () => {
  const isMobile = window.innerWidth <= 767;
  const isSmall = window.innerWidth <= 390;

  const isTab = window.innerWidth >= 768 && window.innerWidth <= 1024;
  return (
    <footer className="footer">
      <div className='footerPadding'>
      <div className="footer-container" width='100%'>
        <div className="footer-symbols" style={{ marginLeft:isTab? '20%': ''}}>
           
        <div className="footer-logo" >
          {/* <img src={scfLogo} alt="scfLogo" style={{width:335,height:130,marginBottom:50,justifyContent:'center', justifyItems:'center', marginTop:50}} /> */}
          <img 
          src="https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/66e57a87d269af52d9f231c5_scf%20logo%20white.webp" 
          loading="lazy"
          sizes="(max-width: 479px) 100vw, (max-width: 767px) 667.2000122070312px, (max-width: 991px) 89vw, (max-width: 1439px) 86vw, 90vw"
          srcset="https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/66e57a87d269af52d9f231c5_scf%20logo%20white.webp 500w, https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/66e57a87d269af52d9f231c5_scf%2520logo%2520white-p-800.png 800w, https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/66e57a87d269af52d9f231c5_scf%20logo%20white.webp 1827w"
           alt=""
           style={{width:!isMobile? '390px':'325px', height: !isMobile? '150px':'125px' ,marginBottom:isMobile? 10 : 50 ,justifyContent:'center', justifyItems:'center', marginTop:isMobile?10:40, marginLeft:isMobile? '30px': 0}}
           />
            </div>
            <div className="social-icons" style={{marginLeft:isMobile?30: 0,marginBottom: isMobile ? 10 : 80,marginTop: isMobile ? 0 : 0, paddingLeft:'10px', paddingRight: '10px', gap: isMobile?10:0}}>
              <a href="https://www.youtube.com/@sood_charity_foundation" target="_blank" rel="noopener noreferrer"> <img src={youtube} alt="youtube" style={{width:isMobile? isSmall?35:40:55, height:isMobile? isSmall?35:40:55}}/></a>
              <a href="https://www.facebook.com/people/Sood-Charity-Foundation/100079526344491/?mibextid=JRoKGi" target="_blank" rel="noopener noreferrer"><img src={fb} alt="fb" style={{width:isMobile? isSmall?35:40:55, height:isMobile? isSmall?35:40:55}}/></a>
              <a href="https://www.instagram.com/sood_charity_foundation/?igsh=d2Y4eTdpYzc2dXow" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="instagram" style={{width:isMobile? isSmall?35:40:55, height:isMobile? isSmall?35:40:55}}/></a>
              <a href="https://www.linkedin.com/company/sood-charity-foundation/" target="_blank" rel="noopener noreferrer"><img src={linkedIn} alt="linkedIn" style={{width:isMobile? isSmall?35:40:55, height:isMobile? isSmall?35:40:55}}/></a>
              <a href="https://x.com/SoodFoundation?ref_src=twsrcgoogletwcampserptwgrauthor&mx=2" target="_blank" rel="noopener noreferrer"><img src={x} alt="x" style={{width:isMobile? isSmall?35:40:55, height:isMobile? isSmall?35:40:55}}/></a>
            </div>
        </div>

        {/* desktop view */}
        <div className="footer-links desktopshow">

       
          <div className="footer-column mobileview">
            <h4>Our Work</h4>
            <a href="https://www.soodcharityfoundation.org/blogs">Blogs</a>
            <a href="https://www.soodcharityfoundation.org/our-campaigns">Our Campaigns</a>
            <a href="https://www.soodcharityfoundation.org/our-projects">Our Projects</a>
            <a href="https://www.soodcharityfoundation.org/ssc-club">Sonu Sood Charity Club</a>
          </div>
          
          <div className="footer-column">
            <h4>Reach Out to us</h4>
            <a href="https://www.soodcharityfoundation.org/contact-us">Contact Us</a>
            <a href="https://donate.soodcharityfoundation.org/">Support Us</a>
            <a href="https://www.soodcharityfoundation.org/our-partner">Partner With Us</a>
            {/* <a href="https://www.soodcharityfoundation.org/">Our Teams</a> */}
          </div>
        
          {/* <div className="footer-column">
            <h4>Reach Out</h4>
            <p>contact@soodcharityfoundation.org</p>
            
          </div> */}
        </div>

        {/* mobile view */}
        <div className="footer-links mobileshow">
        
          <div className="zain">
          <div className="footer-column">
            {/* <h4>Reach Out</h4>
            <p>contact@soodcharityfoundation.org</p> */}
            {/* <div className="social-icons">
              <a href="https://www.soodcharityfoundation.org/"> <img src={youtube} alt="youtube" style={{width:40, height:40}}/></a>
              <a href="https://www.soodcharityfoundation.org/"><img src={fb} alt="fb" style={{width:40, height:40}}/></a>
              <a href="https://www.soodcharityfoundation.org/"><img src={instagram} alt="instagram" style={{width:40, height:40}}/></a>
              <a href="https://www.soodcharityfoundation.org/"><img src={linkedIn} alt="linkedIn" style={{width:40, height:40}}/></a>
              <a href="https://www.soodcharityfoundation.org/"><img src={x} alt="x" style={{width:40, height:40}}/></a>
            </div> */}
          </div>
          <div className="fooot">
          <div className="footer-column" style={{width:'100%'}}>
            <h4>Reach Out to Us</h4>
            <a href="https://www.soodcharityfoundation.org/contact-us">Contact Us</a>
            <a href="https://donate.soodcharityfoundation.org/">Support Us</a>
            <a href="https://www.soodcharityfoundation.org/our-partner">Partner With Us</a>
            {/* <a href="https://www.soodcharityfoundation.org/">Our Teams</a> */}
          </div>

          <div className="footer-column mobileview" style={{marginLeft:10}}>
            <h4>Our Work</h4>
            <a href="https://www.soodcharityfoundation.org/blogs">Blogs</a>
            <a href="https://www.soodcharityfoundation.org/our-campaigns">Our Campaigns</a>
            <a href="https://www.soodcharityfoundation.org/our-projects">Our Projects</a>
            <a href="https://www.soodcharityfoundation.org/ssc-club">Sonu Sood Charity Club</a>
          </div>
          </div>
        
          </div>
          
        </div>
      </div>
      <div className="footer-bottom">
        <p>2025 Sood Charity Foundation. All Rights Reserved</p>
        <div className="footer-bottom-links">
          <a href="https://www.soodcharityfoundation.org/privacy-policy">Privacy Policy</a>
          <a href="https://www.soodcharityfoundation.org/term-and-condition">Terms and Conditions</a>
        </div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
